import './RolesTab.scss';

export { default } from './RolesTab';
